import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import LogInForm from "./LogInForm.js";
import RegistrationForm from "./RegistrationForm.js";
import "./auth.css";

// Thin shell around the branded auth card (opens on Log In). The card supplies
// its own logo, heading, and switch link, so the modal adds only a close button.
function LogInRegisterModal(props) {
  const [showLogin, setShowLogin] = useState(true);

  useEffect(() => { setShowLogin(true); }, [props.show]); // reset to Log In on open

  return (
    <Modal {...props} centered scrollable dialogClassName="auth-modal-dialog">
      <Modal.Body className="auth-modal-body">
        <button className="auth-modal-close" onClick={props.onHide} aria-label="Close">×</button>
        {showLogin
          ? <LogInForm onSwitchToRegister={() => setShowLogin(false)} />
          : <RegistrationForm onSwitchToLogin={() => setShowLogin(true)} />}
      </Modal.Body>
    </Modal>
  );
}

export default LogInRegisterModal;
